import { Button, Heading, Img, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import mrfImage from '../../../../../assets/images/wizard/model-release-form-welcome.svg';
import {
  ChakraUniversalCard,
  UniversalCardSectionWithBorder,
} from '../../../../../components/shared/cards/UniversalCard/UniversalCard';
import { routes } from '../../../../../routes/routesConfig';
import { useHistoryHandler } from '../../../../Home/section/TaskSection/TaskSection';

export const ModelReleaseFormCard = () => {
  const { t } = useTranslation(['payoutDocuments']);
  const location = useLocation();
  const navigateToWizardOrEmailVerification = useHistoryHandler(
    (history) => {
      history.push(routes.wizardMRF.path, { referrer: location.pathname });
    },
    [location]
  );

  return (
    <UniversalCardSectionWithBorder>
      <ChakraUniversalCard
        cardBody={
          <>
            <Img
              src={mrfImage}
              alt={t(
                'payoutDocuments:imgAlt.IllustrationVonZweiPersonenDieSichDieHandGebenImHintergrundSchwebtEiXX'
              )}
            />
            <VStack mt={'4'} spacing={'4'}>
              <Heading size={'xl'} p={0} textAlign={'center'}>
                {t('payoutDocuments:heading.ModelReleaseFormAusfuellen')}
              </Heading>
              <Text textAlign={'center'} color={'gray.500'} p={0}>
                {t(
                  'payoutDocuments:text.UmDeineInhalteVeroffentlichenZuKonnenBenotigenWirDeinEinverstandnisDXX'
                )}
              </Text>
            </VStack>
          </>
        }
        cardFooter={
          <Button
            shadow={'none'}
            children={t('payoutDocuments:button.ModelReleaseFormAusfuellen')}
            onClick={navigateToWizardOrEmailVerification}
          />
        }
      />
    </UniversalCardSectionWithBorder>
  );
};
